import { Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/of";
import { AuthenticationService } from "../../authentication.service";
import { EnvironmentService } from "../../index";
import { Dealer } from "app/_models/dealer";
import { ProlongingsAgreement } from "app/_models/prolongings/prolongingsagreement";

@Injectable()
export class ProlongingsAgreementService {
  private baseUrl: string =
    this.environmentService.getBaseURL() +
    "/api" +
    "/matrix/products/prolongings/agreements";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  getByDealer(dealer_id: string): Observable<ProlongingsAgreement[]> {
    let agreement$ = this.http
      .get(`${this.baseUrl}/dealer/${dealer_id}`, this.makeHeaders())
      .map(mapAgreement)
      .catch((error: any) => {
        // Handle 404 (no agreements found) gracefully
        if (error.status === 404) {
          console.log('No prolonging agreements found for dealer:', dealer_id);
          return Observable.of([]); // Return empty array instead of error
        }
        // For other errors, use the standard error handling
        return handleError(error);
      });
    return agreement$;
  }

  get(id: string): Observable<ProlongingsAgreement> {
    let agreement$ = this.http
      .get(`${this.baseUrl}/${id}`, this.makeHeaders())
      .map((res: Response) => res.json())
      .catch(handleError);
    return agreement$;
  }

  create(
    agreement: Partial<ProlongingsAgreement>, payMonths: number
  ): Observable<ProlongingsAgreement> {
    const segmentId = 237;
    let newAgreement = this.http
      .post(
        `${this.baseUrl}?payMonths=${payMonths}`,
        JSON.stringify({ segmentId, agreement }),
        this.makeHeaders()
      )
      .map(mapAgreement)
      .catch(handleErrorAgreement);
    return newAgreement;
  }

  update(agreement: Partial<ProlongingsAgreement>, payMonths: number): Observable<ProlongingsAgreement> {
    return this.http.put(
      `${this.baseUrl}/${agreement._id}?payMonths=${payMonths}`,
      JSON.stringify({ agreement }),
      this.makeHeaders()
    )
    .map(mapAgreement)
    .catch(handleErrorAgreement);
  }

  delete(id: string): Observable<Response> {
    return this.http
      .delete(`${this.baseUrl}/${id}`, this.makeHeaders())
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      ); //...errors if any
  }

  acceptAgreement(
    agreement: ProlongingsAgreement,
    dealer: Dealer,
    regnr: string,
    mauticId: string
  ): Observable<Response> {
    const params = {
      agreement,
      dealer,
      regnr,
      mauticId,
    };
    return this.http
      .put(
        `${this.baseUrl}/${agreement._id}/accept`,
        { params },
        this.makeHeaders()
      )
      .map((res: Response) => res.json())
      .catch(handleError);
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}

function toAgreement(r: any): ProlongingsAgreement {
    return r as ProlongingsAgreement;
}

function mapAgreement(response: Response): ProlongingsAgreement {
  return toAgreement(response.json());
}

function handleError(error: any) {
  let errorMsg =
    error.message ||
    `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
  console.error(errorMsg);

  return Observable.throw(errorMsg);
}

function handleErrorAgreement(error: any) {
  let errorMsg =
   "Noget gik galt ved generering af en aftale.";
  alert(errorMsg)
  return Observable.throw(error);
}




// WEBPACK FOOTER //
// ./src/app/_services/matrix/products/prolongings-agreement.service.ts